import features from 'lib/common/features';

function augmentPrices(prices) {
  if (features.isEnabled('priceTypeLimits')) {
    let priceLimits = features.getOption('priceTypeLimits', 'prices');
    prices = prices.map(item => {
      for (let x = 0; x < priceLimits.length; x++) {
        let _ref = priceLimits[x];
        if (_ref.priceTypeIds.indexOf(item.price_type) !== -1) {
          item.min_tickets = _ref.limits.min_tickets;
          item.max_tickets = _ref.limits.max_tickets;
          item.multiples_of_tickets = _ref.limits.multiples_of_tickets;
        }
      }
      return item;
    });
  }

  return prices;
}

export function checkMaxLimit(prices, lineItems) {
  prices = augmentPrices(prices);

  let maxLimitPrices = prices.filter(item => {
    return item.max_tickets;
  });

  let matchingLineItems;
  let error;

  if (maxLimitPrices) {
    maxLimitPrices.forEach(item => {
      matchingLineItems = lineItems.filter(lineItem => {
        return (
          parseInt(lineItem.priceData.price_type, 10) ===
          parseInt(item.price_type, 10)
        );
      });

      if (
        matchingLineItems &&
        matchingLineItems.length > 0 &&
        matchingLineItems.length > parseInt(item.max_tickets, 10)
      ) {
        error = `You can only have ${item.max_tickets} ${
          item.description
        } tickets.`;
        return error;
      }
    });
  }

  return false;
}

export function checkMinLimit(prices, lineItems) {
  prices = augmentPrices(prices);

  let minLimitPrices = prices.filter(item => {
    return item.min_tickets;
  });

  let matchingLineItems;
  let error = '';

  if (minLimitPrices) {
    minLimitPrices.forEach(item => {
      matchingLineItems = lineItems.filter(lineItem => {
        return (
          parseInt(lineItem.priceData.price_type, 10) ===
          parseInt(item.price_type, 10)
        );
      });

      if (
        matchingLineItems &&
        matchingLineItems.length > 0 &&
        matchingLineItems.length < parseInt(item.min_tickets, 10)
      ) {
        error = `You must select ${item.min_tickets} ${
          item.description
        } tickets.`;
        return error;
      }
    });
  }

  return false;
}

export function checkMultipleLimit(prices, lineItems) {
  prices = augmentPrices(prices);

  var multipleLimitPrices = prices.filter(item => {
    return item.multiples_of_tickets;
  });

  var matchingLineItems;
  var error = '';

  if (multipleLimitPrices) {
    multipleLimitPrices.forEach(item => {
      matchingLineItems = lineItems.filter(lineItem => {
        return (
          parseInt(lineItem.priceData.price_type, 10) ===
          parseInt(item.price_type, 10)
        );
      });

      if (
        matchingLineItems &&
        matchingLineItems.length > 0 &&
        matchingLineItems.length % parseInt(item.multiples_of_tickets, 10) > 0
      ) {
        error = `You must have multiples of ${item.multiples_of_tickets} ${
          item.description
        } tickets.`;
        return error;
      }
    });
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/cart/ticketLimit.js